module.exports = __webpack_public_path__ + "static/media/zkx.d771403f.png";